import type {OrderDetailData} from 'modules/Orders/types';

import {Divider} from '@ds/components';
import {numberFormat} from 'utils/Helper';

import OrderDataRow from '../../../components/common/OrderDataRow/OrderDataRow';

type OrderSummaryProps = {
  totalGoodsAmount?: number;
  vendorRevenue?: number;
  revenueDiff?: number;
  discount?: OrderDetailData['discount'];
  revised?: boolean;
  customerComment?: string;
};

const OrderSummary: React.FC<OrderSummaryProps> = ({
  totalGoodsAmount,
  vendorRevenue,
  revenueDiff,
  discount,
  revised,
  customerComment
}) => {
  return (
    <div className="flex min-h-12.5 flex-col">
      <OrderDataRow
        title="مجموع مبلغ کالاها"
        value={`${numberFormat(totalGoodsAmount || 0)} تومان`}
      />
      {Boolean(discount?.vendor) && (
        <OrderDataRow
          title="تخفیف وندور"
          tone="error"
          value={`${numberFormat(discount?.vendor || 0)}- تومان`}
        />
      )}
      {revised && (
        <OrderDataRow title="فروش شما" value={`${numberFormat(vendorRevenue || 0)} تومان`} />
      )}
      {Boolean(revenueDiff) && (
        <OrderDataRow title="مابه‌تفاوت درآمد" value={`${numberFormat(revenueDiff || 0)} تومان`} />
      )}
      {customerComment && (
        <>
          <div className="flex flex-col gap-2.5 p-2.5">
            <span className="text-body-sm text-gray-09">توضیحات مشتری</span>
            <span className="text-justify text-body-sm text-gray-07">{customerComment}</span>
          </div>
          <Divider className="bg-gray-03" />
        </>
      )}
    </div>
  );
};

export default OrderSummary;
